export default {"src":"/_next/static/media/5-icon.d17b4b4b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};